import React from "react";
import { Col, Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";
import style from "./css/AdminSettings_Sidebar.module.css";

const AdminSettings_Sidebar = () => {
  return (
    <Navbar
      collapseOnSelect
      expand="md"
      bg="dark"
      variant="dark"
      className={`${style.sidebar}`}
    >
      <Navbar.Toggle aria-controls="admin-settings-sidebar-nav" />
      <Navbar.Collapse
        id="admin-settings-sidebar-nav"
        className="justify-content-center"
      >
        <Nav className="me-auto flex-column w-100">
          <LinkContainer to="/admin/settings">
            <Nav.Link>Settings</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/admin/addressUpload">
            <Nav.Link>Address upload</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/admin/schoolUpload">
            <Nav.Link>Schools</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/admin/frlUpload">
            <Nav.Link>Free & Reduced Lunch</Nav.Link>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
      {/* </Col> */}
    </Navbar>
  );
};

export default AdminSettings_Sidebar;
